import './B2BFormContainer.css';

import React from 'react';
import { Divider, Paper, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import clsx from 'clsx';
import CustomButton from './CustomButton';
import { generateClassName } from './helpers';
import PropTypes from 'prop-types';

const B2BFormContainer = React.forwardRef(({ title, onClose, buttonsConfig: buttons, children, className, orientation = 'vertical', showDivider = true }, ref) => {
    const bodyClassName = clsx(
        generateClassName("b2b-form", "-body", className),
        {
            'b2b-form-body-horizontal': orientation === 'horizontal',
        }
    );
    return (
        <Paper elevation={2} className={generateClassName("b2b-form", "-container-paper", className)}>
            {title && (
                <div className={generateClassName("b2b-form", "-container-banner", className)} ref={ref}>
                    <Typography>{title}</Typography>
                    {onClose && (
                        <IconButton onClick={onClose} color="primary" className={generateClassName("b2b-form", "-container-banner-close-button", className)}>
                            <Close />
                        </IconButton>
                    )}
                </div>
            )}
            <div className={bodyClassName}>
                <div className={generateClassName("b2b-form", "-container-content", className)}>
                    {children}
                </div>
                {showDivider && buttons && (
                    <Divider
                        orientation={orientation === 'horizontal' ? 'vertical' : 'horizontal'}
                        variant={orientation === 'horizontal' ? 'middle' : 'fullWidth'}
                        flexItem
                    />
                )}
                {buttons && (
                    <div className={generateClassName("b2b-form", "-container-buttons", className)}>
                        {buttons.map((button, index) => (
                            <CustomButton key={index}
                                {...button}>
                                {button.label}
                            </CustomButton>
                        ))}
                    </div>
                )}
            </div>
        </Paper>
    );
});

B2BFormContainer.displayName = 'B2BFormContainer';

B2BFormContainer.propTypes = {
    orientation: PropTypes.oneOf(['vertical', 'horizontal']),
    showDivider: PropTypes.bool,
};

B2BFormContainer.defaultProps = {
    orientation: 'vertical',
    showDivider: true,
};

export default B2BFormContainer;
